import 'rxjs/add/observable/of';
import { Injectable } from '@angular/core';
import { DataSourceUtils } from '../../../shared/utils/data-source-utils';
import { Invoice } from './invoice';
import { GetInvoicesAction } from './invoices.action';
import { getInvoicesListSelector, getInvoicesTotalSelector } from './invoices.reducer';

@Injectable()
export class InvoicesTableDataSource extends DataSourceUtils<Invoice> {
  update() {
    this.store.dispatch(new GetInvoicesAction());
  }

  onConnect() {
    return this.store.select(getInvoicesListSelector).withLatestFrom(this.store.select(getInvoicesTotalSelector));
  }
}
